export default __webpack_public_path__ + "static/media/banker_win.165e0981.gif";